import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	CleanupWizardData,
	CleanupWizardMetrics,
	StatusCleanupWizard,
} from '@/interfaces';

class CleanupWizard {
	constructor(private client: AxiosInstance) {}

	async getCleanupWizardList(
		page: number,
		limit: number,
		search?: string,
		reason?: string,
		status?: StatusCleanupWizard,
		clientId?: string
	): Promise<HttpResponse<CleanupWizardData>> {
		const auxParams = [];
		search && auxParams.push('search=' + search);
		auxParams.push('isOrderAlph=' + true);
		reason && auxParams.push('reason=' + reason);
		status && auxParams.push('status=' + status);
		clientId && auxParams.push('user_id=' + clientId);
		const params = auxParams.join('&');
		return this.client.get(
			params.length > 0
				? `/clean-up-wizard?page=${page}&limit=${limit}&${params}`
				: `/clean-up-wizard?page=${page}&limit=${limit}`
		);
	}

	async getStatusFilter(): Promise<HttpResponse<StatusCleanupWizard[]>> {
		return this.client.get('/clean-up-wizard/status');
	}
	async getReasonFilter(): Promise<HttpResponse<string[]>> {
		return this.client.get('/clean-up-wizard/reasons');
	}
	async getCleanupWizardMetrics(): Promise<HttpResponse<CleanupWizardMetrics>> {
		return this.client.get('/clean-up-wizard/metrics');
	}
	async putContactCustomer(
		userId: string
	): Promise<HttpResponse<CleanupWizard>> {
		return this.client.put(`/clean-up-wizard/${userId}/contact-customer`);
	}
	async putDeactivateAccount(
		userId: string
	): Promise<HttpResponse<CleanupWizard>> {
		return this.client.put(`/clean-up-wizard/${userId}/deactive-account`);
	}
	async putReactivateAccount(
		userId: string
	): Promise<HttpResponse<CleanupWizard>> {
		return this.client.put(`/clean-up-wizard/${userId}/reactivate-account`);
	}
	async putVerifyCustomer(
		userId: string
	): Promise<HttpResponse<CleanupWizard>> {
		return this.client.put(`/clean-up-wizard/${userId}/customer-verified`);
	}
	async flagClient(userId: string, reason: string): Promise<HttpResponse<any>> {
		return this.client.post(`/clean-up-wizard/flag-user/${userId}/${reason}`);
	}
}

export const cleanupWizardService = new CleanupWizard(axiosClient);
